import { render, staticRenderFns } from "./RePassword.vue?vue&type=template&id=07f5b65c&scoped=true&"
import script from "./RePassword.vue?vue&type=script&lang=js&"
export * from "./RePassword.vue?vue&type=script&lang=js&"
import style0 from "./RePassword.vue?vue&type=style&index=0&id=07f5b65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5b65c",
  null
  
)

export default component.exports